import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import Logo from '../../components/Logo';
import AuthEmbed from '../../components/authentication/AuthEmbed';
import useTrainer from '../../hooks/useTrainer';
import Page from '../Page';

const Login = () => {
  const navigate = useNavigate();
  const authPromptRef = useRef(null);
  const { data } = useTrainer();
  const [showAuthPrompt, setShowAuthPrompt] = useState(true);

  if (!data) {
    return <></>;
  }
  const slug = data?.webPage?.slug;

  return (
    <Page title="Login | TempoKit">
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Container maxWidth="sm" sx={{ py: '80px' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 8,
            }}
          >
            <Logo
              sx={{
                height: 40,
                width: 40,
              }}
            />
          </Box>

          {showAuthPrompt && (
            <AuthEmbed
              ref={authPromptRef}
              show="login"
              onSuccess={(user) => {
                setShowAuthPrompt(false);
                navigate(`/${slug}/dashboard`);
              }}
              onClose={() => {}}
            />
          )}
        </Container>
      </Box>
    </Page>
  );
};

export default Login;
